import dev from './development';
import prod from './production';

export default process.env.REACT_APP_STAGE === 'production' ? prod : dev;
